<template>
  <div class="b-trunks__menu">
    <ul class="b-nav-menu">
      <li
        v-for="(item, i) in computed_menu"
        :id="item.title"
        :key="item.title"
        :ref="item.title"
        :class="{ active: i === activeItem }"
      >
        <div
          v-if="item.single"
          class="b-nav-menu__title b-nav-menu__title--uppercase"
          @click="filter(item.name, item.id, true, i)"
        >
          <template> {{ item.name }} </template>
        </div>
        <div
          v-else
          class="b-nav-menu__title"
          @click="item.subPoints ? open_submenu(i) : filter(item.name, item.id)"
        >
          {{ $te(item.title) ? $t(item.title) : item.name }}
          <i v-if="item.subPoints" class="down"></i>
        </div>
        <ul class="b-nav-menu__sub1">
          <li
            v-for="sub_item in item.subPoints"
            :ref="sub_item.name"
            :key="sub_item.name"
            :class="{ active: sub_item.name === activeSubItem }"
          >
            <div
              v-if="sub_item.hide_from_ind ? !ind_locale : !sub_item.hide_from_ind"
              class="b-nav-menu__title"
              @click="filter(sub_item.name, sub_item.id)"
            >
              {{ $te(sub_item.title) ? $t(sub_item.title) : sub_item.name }}
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import { getFirstServiceName } from '@utils/services';

  export default {
    props: {
      tree_menu: {
        type: Array,
        default: () => []
      }
    },
    data: function () {
      return {
        activeItem: 0,
        activeSubItem: 0
      };
    },

    computed: {
      computed_menu() {
        return this.tree_menu.map((i) => {
          return i.single
            ? { ...i }
            : {
              ...i,
              title: `prices.common.type.${i.name}.title`,
              subPoints: i?.subPoints?.map((k) => ({
                ...k,
                title: `prices.common.type.${i.name}.${k.name}`
              }))
            };
        });
      }
    },

    mounted() {
      this.activeSubItem = getFirstServiceName(this.computed_menu);
    },

    created() {
      const firstElement = getFirstServiceName(this.computed_menu);
      const merged = [].concat.apply(
        [],
        this.computed_menu.map((i) => i.subPoints)
      );
      const firstId = merged.find((i) => i?.name === firstElement)?.id;

      this.$emit('selected_items', firstElement, firstId);
    },

    methods: {
      filter(name, subItemID, showSingleActive, index) {
        if (showSingleActive) {
          this.activeItem = index;
        } else {
          this.activeSubItem = name;
        }
        this.$emit('selected_items', name, subItemID);
      },

      open_submenu(i) {
        if (this.activeItem === i) {
          this.activeItem = '';
        } else {
          this.activeItem = i;
        }
      }
    }
  };
</script>

<style lang="scss">
  .b-trunks__menu {
    ul {
      list-style: none;
      background: #fff;

      li {
        .b-nav-menu__title {
          line-height: 24px;
          padding: 13px 10px 13px 15px;
          cursor: pointer;
          transition: all 0.4s ease-in-out;
          background: #fff;
          width: 100%;
          position: relative;
          color: #34495e;
          border-right: 2px solid #fff;

          &--uppercase {
            text-transform: uppercase;
          }

          i.down {
            border: solid #34495e;
            border-width: 0 1px 1px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            position: absolute;
            right: 20px;
            top: 23px;
            transition: all 0.2s ease-in-out;
          }

          &:hover {
            background-color: #f5f6f8;
            border-color: #f5f6f8;
            transition: all 0.4s ease-in-out;
            color: #2196f3;

            i.down {
              border-color: #2196f3;
            }
          }
        }

        ul {
          display: none;

          li {
            .b-nav-menu__title {
              padding-left: 30px;
            }
          }
        }

        &.active {
          & > .b-nav-menu__title {
            background-color: #f5f6f8;
            color: #2196f3;
            border-right: 2px solid #2196f3;
          }

          i.down {
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            top: 21px;
            right: 18px;
            color: #2196f3;
          }

          ul {
            display: block;

            li {
              color: #000;
            }
          }
        }
      }

      &.b-nav-menu {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }

      & > li {
        margin-top: -1px;
      }
    }
  }
</style>
